export const FORMAT_LABELS = {
  paragraph: ["Paragraphe", "Paragraph"],
  bullets: ["Points clés", "Key points"],
  both: ["Paragraphe + points", "Paragraph + key points"],
  enseignant: ["Enseignant", "Teacher"],
  revision: ["Fiche de révision (élève)", "Revision sheet (pupil)"],
  revision_dys: ["Fiche de révision DYS", "DYS revision sheet"],
  metaphore: ["Métaphores (résumé imagé)", "Metaphors (illustrated summary)"],
  poeme: ["Poème et récitation", "Poem and recitation"],
  biographie: ["Fiche encyclopédique", "Encyclopedic sheet"],
  philo: ["Philo + citations", "Philosophy + quotes"],
  solve: ["Explication & résolution", "Explanation & solution"],
  dissertation: ["Dissertation", "Essay"],
};

export const formatLabel = (key, en) => (FORMAT_LABELS[key] ? FORMAT_LABELS[key][en ? 1 : 0] : key);
